import { DEFAULT_LAYOUT } from '../base';
import { type AppRouteRecordRaw } from '../types';
import { IconLocation } from '@arco-design/web-vue/es/icon';

const routes: AppRouteRecordRaw = {
  path: '/exam-site',
  redirect: '/exam-site/list',
  component: DEFAULT_LAYOUT,
  meta: {
    title: '考点管理',
    icon: IconLocation,
    order: 1,
    hideChildrenInMenu: true,
    roles: ['admin'],
  },
  children: [
    {
      path: 'list',
      component: () => import('@/views/exam-site/index.vue'),
      meta: {},
    },
    {
      path: 'add-edit',
      component: () => import('@/views/exam-site/add-edit.vue'),
      meta: {
        title: '新增考点',
        hideInMenu: true,
        ignoreCache: true,
      },
    },
    {
      path: 'add-edit/:id',
      component: () => import('@/views/exam-site/add-edit.vue'),
      props: true,
      meta: {
        title: '编辑考点',
        hideInMenu: true,
        ignoreCache: true,
      },
    },
    {
      path: 'info/:id',
      component: () => import('@/views/exam-site/info.vue'),
      props: true,
      meta: {
        title: '考点信息',
        hideInMenu: true,
        ignoreCache: true,
      },
    },
  ],
};

export default routes;
